import { useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { IServiceType } from '../../../interfaces';
import { getServiceTypeListAllShowInRating } from '../../../api';

export function useGetServiceTypes(onLoad?: (data: IServiceType[]) => void) {
  const [{ loading, data, error }, setData] = useState<{
    loading: boolean;
    error: string | null;
    data: IServiceType[];
  }>({ loading: false, error: null, data: [] });

  const fetchServiceTypes = async () => {
    setData((prevState) => ({ ...prevState, loading: true }));

    try {
      const response = await getServiceTypeListAllShowInRating();
      setData((prevState) => ({ ...prevState, data: response }));
      onLoad?.(response);
    } catch (error) {
      setData((prevState) => ({
        ...prevState,
        data: [],
        error: (error as AxiosError).response?.data.message,
      }));
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  };

  useEffect(() => {
    fetchServiceTypes();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { loading, data, error, fetchServiceTypes };
}
